import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { renderTemplates } from "@infotech/widget-report-generator/bundle"

const Templates = ({
  onCreate,
  onEdit,
  getToken,
  reportServiceUrl,
  filesServiceUrl,
  requiredTags,
  securityServiceURL,
}) => {
  const root = useRef(null)

  useEffect(() => {
    renderTemplates(
      root.current,
      {
        env: {
          REPORT_SERVICE: reportServiceUrl,
          FILES_SERVICE: filesServiceUrl,
          SECURITY_SERVICE: securityServiceURL,
        },
        getToken,
      },
      {
        onCreate,
        onEdit,
        requiredTags,
      },
    )
  }, [])

  return <div style={{ height: `100%` }} ref={root} />
}

Templates.propTypes = {
  onCreate: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  getToken: PropTypes.func.isRequired,
  reportServiceUrl: PropTypes.string.isRequired,
  filesServiceUrl: PropTypes.string.isRequired,
  securityServiceURL: PropTypes.string.isRequired,
  requiredTags: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default Templates
